export const auStates = ['ACT-1', 'NSW-1', 'NSW-2', 'NT-1', 'QLD-1', 'QLD-2', 'SA-1', 'TAS-1', 'VIC-1', 'WA-1', 'WA-2'];

export const allStatesAndCountries = [...auStates, 'NewCal-1', 'NZ-1', 'Tahiti-1'];

/**
 * Gets the orders created this week
 * @param {*} orders the list of orders
 * @returns the list of orders created this week
 */
export const getThisWeekOrders = (orders) => {
    if (!orders) return [];

    const today = new Date();
    const currentDay = today.getDay(); // 0 is Sunday, 1 is Monday, etc.

    // Calculate days since last Monday (or 0 if today is Monday)
    const daysSinceMonday = currentDay === 0 ? 6 : currentDay - 1;

    // Create a date object for this week's Monday at 00:00:00
    const monday = new Date(today);
    monday.setDate(today.getDate() - daysSinceMonday);
    monday.setHours(0, 0, 0, 0);

    return orders.filter((order) => {
        const orderDate = new Date(order.createdAt);
        // Return true if the order was created on or after Monday
        return orderDate >= monday;
    });
};

/**
 * Gets the orders for the given territories
 * @param {*} orders the list of orders
 * @param {*} territories the list of territories
 */
export const getOrdersForTerritories = (orders, territories = []) => {
    if (!orders) return [];
    return orders.filter((order) => territories.includes(order.territory) && order.refinement !== 'Yes');
};

/**
 * Gets the refinement orders for the given territories
 * @param {*} orders the list of orders
 * @param {*} territories the list of territories
 */
export const getRefinementOrdersForTerritories = (orders, territories = []) => {
    if (!orders) return [];
    return orders.filter((order) => territories.includes(order.territory) && order.refinement === 'Yes');
};
